<template>
  <main :class="$options.name">
    <Head
      title="Say Hello | Nice Bike"
      description="Interested in a custom build or just want to pick our brain about some new gear?"
      keywords="nice bike"
      image="https://ridenicebike.com/img/social.jpg"
      url="https://ridenicebike.com/contact"
    />
    <Loader v-if="loading" />
    <Hero v-if="!errored && !loading && page.hero.fields" :img="page.hero.fields.file.url">
      <RichText :value="page.heroText" />
    </Hero>
    <article>
      <section class="Box innerWrap">
        <form method="post" @submit.prevent="handleSubmit">
          <input type="hidden" name="form-name" value="contact" />
          <fieldset>
            <label for="name">
              <h5>Your name</h5>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="ex. Firsty McLasty"
              v-model="form.name"
            />
          </fieldset>
          <fieldset>
            <label for="email">
              <h5>Your email</h5>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="ex. email@website.com"
              v-model="form.email"
            />
          </fieldset>
          <fieldset>
            <label for="message">
              <h5>Your message</h5>
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="I love Nice Bike…"
              v-model="form.message"
            ></textarea>
          </fieldset>
          <fieldset>
            <Button :disabled="isValid" label="Send message" />
          </fieldset>
        </form>
      </section>
      <figure :class="$options.name + '__map'">
        <RichText
          v-if="!errored && !loading"
          class="innerWrap"
          :value="page.content"
          tag="figcaption"
        />
        <Map />
      </figure>
    </article>
  </main>
</template>
<script>
import Button from "@/components/Button";
import Hero from "@/components/Hero";
import Loader from "@/components/Loader";
import Map from "@/components/Map";
import RichText from "@/components/RichText";
export default {
  name: "Contact",
  components: { Button, Hero, Loader, Map, RichText },
  computed: {
    isValid() {
      if (this.form.name && this.form.email && this.form.message) {
        return false;
      } else {
        return true;
      }
    }
  },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      errored: false,
      form: {
        name: null,
        email: null,
        message: null
      },
      loading: true,
      page: []
    };
  },
  methods: {
    getContact() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntry("25FbFcDqXbe3J3kiJ49Nci")
        .then(entry => {
          this.page = entry.fields;
          this.loading = false;
        })
        .catch(error => {
          this.errored = true;
        });
    },
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleSubmit(e) {
      if (!this.isValid) {
        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: this.encode({
            "form-name": "contact",
            ...this.form
          })
        })
          .then(() => {
            this.$router.push("/contact/thanks");
          })
          .catch(() => {
            this.$router.push("error");
          });
      } else {
        console.log("No data yo!");
      }
    }
  },
  mounted() {
    this.getContact();
  }
};
</script>
<style lang="scss">
.Contact {
  > article {
    padding-bottom: 0;
  }
  .Box {
    margin-top: rem(32);
  }
  form {
    > * + * {
      margin-top: rem(16);
    }
    > *[type="hidden"] {
      display: none;
      + * {
        margin-top: 0;
      }
    }
    label {
      color: var(--base-mid);
    }
    input,
    textarea {
      @include smooth;
      @include typeSize(m, m);
      background-color: var(--contrast);
      border: rem(1) solid var(--base-light);
      border-radius: rem(4);
      margin-top: rem(8);
      padding: rem(8);
      &::placeholder {
        color: var(--base-light);
      }
      &:hover {
        border-color: var(--base-mid);
      }
      &:focus {
        border-color: var(--highlight);
      }
    }
  }
  &__map {
    margin-top: rem(16);
    @include breakpoint(m) {
      margin-top: rem(32);
    }
    figcaption {
      margin-bottom: rem(16);
      @include breakpoint(m) {
        margin-bottom: rem(32);
      }
      h2 {
        color: var(--base-mid);
        margin-bottom: rem(16);
      }
    }
    #map {
      margin-left: rem(-16);
      margin-right: rem(-16);
      @include breakpoint(m) {
        margin-left: rem(-32);
        margin-right: rem(-32);
      }
    }
  }
}
</style>